export const UPDATE_MESSAGE = "Requested Vin not available in PLM database, Would you like to update"
export const UPDATE_MESSAGE_TRIMMED = "Requested Vin not available in PLM database."